const [w,d] = [window,document];

class replaceDatepicker {
  constructor (queries) {
    queries.forEach(q => this.inputInit(q) );
  }
  inputInit (query) {
    const input = d.querySelector(query);
    const $datepickerInput = $(`<input type="text" class="is-datepicker" size="15" readonly />`);
    const $timeselect = $(`<select />`);
    const applyVal = () => {
      input.value = `${$datepickerInput.val()} ${$timeselect.val()}`;
    }
    ['10:00','11:00','12:00','13:00','14:00','15:00','16:00','17:00'].map( v => $timeselect.append(`<option>${v}</option>`));
    input.type = 'hidden';
    $(input).parent().prepend($timeselect);
    $(input).parent().prepend($datepickerInput);
    $timeselect.wrap('<div class="select" />');
    $datepickerInput.datepicker({
      clearBtn: true,
      language: 'ja',
      startDate: 'tomorrow',
      format:"yyyy年mm月dd日",
    });
    $timeselect.on('change', applyVal );
    $datepickerInput.on('change', applyVal );
  }
}

const init = () => {
  new replaceDatepicker([
    'input[name="text_0"]',
    'input[name="text_1"]',
    'input[name="text_5"]',
  ]);
}

export default function RESERVE () {
  w.jQuery = $
  w.addScript({src:'/asset/js/vendor/bootstrap-datepicker.min.js', defer:'true'});
  w.addScript({src:'/asset/js/vendor/bootstrap-datepicker.ja.min.js', defer:'true'});
  w.addStylesheet({href:'https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.8.0/css/bootstrap-datepicker3.standalone.min.css', media:'screen, projection, print'});
  w.addEventListener('load', init );
}